import React from 'react';
import { Button, Row, Col } from 'antd';
import {
  CheckCircleOutlined,
  UserOutlined,
  SearchOutlined,
  HeartOutlined,
  MessageOutlined
} from '@ant-design/icons';

function Hero() {
  const handleGetStarted = () => {
    // Navigate to registration page
    window.location.href = '/register';
  };

  const handleLogin = () => {
    // Navigate to login page
    window.location.href = '/login';
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      position: 'relative',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center'
    }}>
      {/* Animated Background Elements */}
      <div style={{
        position: 'absolute',
        top: '10%',
        right: '10%',
        width: '300px',
        height: '300px',
        background: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '50%',
        animation: 'float 6s ease-in-out infinite'
      }}></div>
      
      <div style={{
        position: 'absolute',
        bottom: '20%',
        left: '5%',
        width: '200px',
        height: '200px',
        background: 'rgba(255, 215, 0, 0.2)',
        borderRadius: '50%',
        animation: 'float 4s ease-in-out infinite reverse'
      }}></div>

      {/* Main Container */}
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        padding: '0 24px',
        width: '100%',
        zIndex: 2,
        position: 'relative'
      }}>
        <Row align="middle" gutter={[48, 48]}>
          {/* Left Content */}
          <Col xs={24} lg={14}>
            <div style={{ paddingRight: '40px' }}>
              {/* Badge */}
              <div style={{
                display: 'inline-flex',
                alignItems: 'center',
                background: 'rgba(255, 255, 255, 0.2)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255, 255, 255, 0.3)',
                borderRadius: '50px',
                padding: '8px 20px',
                marginBottom: '32px',
                color: 'white',
                fontSize: '14px',
                fontWeight: '500'
              }}>
                <CheckCircleOutlined style={{ marginRight: '8px', color: '#ffd700' }} />
                Exclusively for Brahmin Community
              </div>

              {/* Main Headline */}
              <h1 style={{
                fontSize: 'clamp(2.5rem, 6vw, 4.5rem)',
                fontWeight: '800',
                lineHeight: '1.1',
                color: 'white',
                marginBottom: '24px',
                fontFamily: 'system-ui, -apple-system, sans-serif'
              }}>
                Find Your Perfect{' '}
                <span style={{
                  background: 'linear-gradient(45deg, #ffd700, #ffed4e)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text'
                }}>
                  Brahmin
                </span>
                {' '}Life Partner
              </h1>

              {/* Subtitle */}
              <p style={{
                fontSize: 'clamp(1.1rem, 2vw, 1.4rem)',
                color: 'rgba(255, 255, 255, 0.9)',
                lineHeight: '1.6',
                marginBottom: '40px',
                maxWidth: '600px'
              }}>
                A sacred matrimony platform designed exclusively for the Brahmin community. Where tradition meets technology to create meaningful, culturally-rooted connections.
              </p>

              {/* Features List */}
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
                marginBottom: '40px'
              }}>
                {[
                  'Free profile creation and browsing',
                  'Advanced subcaste and cultural filters',
                  'Horoscope matching capabilities',
                  'Secure messaging and privacy controls'
                ].map((feature, index) => (
                  <div key={index} style={{
                    display: 'flex',
                    alignItems: 'center',
                    color: 'rgba(255, 255, 255, 0.9)',
                    fontSize: '16px'
                  }}>
                    <CheckCircleOutlined style={{
                      color: '#ffd700',
                      marginRight: '12px',
                      fontSize: '18px'
                    }} />
                    {feature}
                  </div>
                ))}
              </div>

              {/* CTA Buttons */}
              <div style={{
                display: 'flex',
                gap: '16px',
                alignItems: 'center',
                flexWrap: 'wrap'
              }}>
                <Button
                  type="primary"
                  size="large"
                  onClick={handleGetStarted}
                  style={{
                    background: '#ffd700',
                    borderColor: '#ffd700',
                    color: '#333',
                    fontWeight: 'bold',
                    height: '56px',
                    padding: '0 32px',
                    borderRadius: '28px',
                    fontSize: '16px',
                    boxShadow: '0 8px 25px rgba(255, 215, 0, 0.3)',
                    border: 'none'
                  }}
                >
                  Create Free Profile
                </Button>
                
                <Button
                  size="large"
                  onClick={handleLogin}
                  style={{
                    background: 'transparent',
                    borderColor: 'rgba(255, 255, 255, 0.3)',
                    color: 'white',
                    height: '56px',
                    padding: '0 24px',
                    borderRadius: '28px',
                    fontSize: '16px',
                    backdropFilter: 'blur(10px)'
                  }}
                >
                  Already a Member? Login
                </Button>
              </div>

              {/* Trust Message */}
              <p style={{
                marginTop: '24px',
                color: 'rgba(255, 255, 255, 0.7)',
                fontSize: '14px'
              }}>
                ✨ Completely free to join • No hidden charges • Trusted platform
              </p>
            </div>
          </Col>

          {/* Right Content - Feature Cards */}
          <Col xs={24} lg={10}>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              gap: '20px',
              perspective: '1000px'
            }}>
              {[
                {
                  icon: <UserOutlined />,
                  title: 'Authentic Profiles',
                  desc: 'Detailed profiles with family background and cultural information',
                  color: '#ff6b6b'
                },
                {
                  icon: <SearchOutlined />,
                  title: 'Cultural Matching',
                  desc: 'Search by subcaste, gothram, and traditional preferences',
                  color: '#4ecdc4'
                },
                {
                  icon: <HeartOutlined />,
                  title: 'Brahmin Values',
                  desc: 'Connect with those who share your cultural heritage',
                  color: '#45b7d1'
                },
                {
                  icon: <MessageOutlined />,
                  title: 'Private Messaging',
                  desc: 'Secure communication with potential matches',
                  color: '#f9ca24'
                }
              ].map((feature, index) => (
                <div
                  key={index}
                  style={{
                    background: 'rgba(255, 255, 255, 0.15)',
                    backdropFilter: 'blur(20px)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    borderRadius: '20px',
                    padding: '24px',
                    color: 'white',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer',
                    transform: index % 2 === 1 ? 'translateY(20px)' : 'translateY(0)',
                    animation: `slideInUp 0.6s ease-out ${index * 0.1}s both`
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = `translateY(-10px) ${index % 2 === 1 ? 'translateY(10px)' : ''}`;
                    e.currentTarget.style.boxShadow = '0 20px 40px rgba(0, 0, 0, 0.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = index % 2 === 1 ? 'translateY(20px)' : 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  <div style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: '12px',
                    background: feature.color,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '20px',
                    color: 'white',
                    marginBottom: '16px',
                    boxShadow: `0 8px 20px ${feature.color}33`
                  }}>
                    {feature.icon}
                  </div>
                  
                  <h4 style={{
                    color: 'white',
                    fontSize: '16px',
                    fontWeight: '600',
                    marginBottom: '8px',
                    margin: '0 0 8px 0'
                  }}>
                    {feature.title}
                  </h4>
                  
                  <p style={{
                    color: 'rgba(255, 255, 255, 0.8)',
                    fontSize: '13px',
                    lineHeight: '1.4',
                    margin: 0
                  }}>
                    {feature.desc}
                  </p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </div>

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        
        @keyframes slideInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
}

export default Hero;